import { render, staticRenderFns } from "./relateButton.vue?vue&type=template&id=1f494e27&"
import script from "./relateButton.vue?vue&type=script&lang=ts&"
export * from "./relateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports